import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import { Formik } from 'formik';
import { LabelWithValue } from '../../../document/components/label-with-value';
import { DocumentTypeService } from '../../../../services/lookup-data/document-type.service';


const EditDocumentTypeModal = (props: any) => {

    const { onClose, isOpen, onSaveComplete, isUrl, data } = props;    
    const [titleForm, setTitleForm] = useState<string>();
    const [saveLabel, setSaveLabel] = useState<string>();

    const handleOnSubmit = async (values: any) => {
        const fields = {
            Title: values.label
        }

        const result = data.value ? await DocumentTypeService.update(data.value, fields) : await DocumentTypeService.create(fields);
        onSaveComplete(result);
        onClose();
    };

  

    useEffect(() => {
     
        let titleFormLocal: string = "";
        if(data)
        {    
            if(data.value) {
                titleFormLocal = data.value ? "Chỉnh sửa loại tài liệu" :  "Thêm loại tài liệu";
            }
            else {
                titleFormLocal = data.value ? "Chỉnh sửa loại tài liệu" :  "Thêm loại tài liệu";
            }
      

            setSaveLabel(data.value ? "Cập nhật" : "Thêm");
            setTitleForm(titleFormLocal);
        }               

    }, [data]);

    return (
        <Modal
            show={isOpen}
            onHide={onClose}
            centered
            size={(isUrl ? 'lg' : 'xl')}
            className="edit-department-detail-modal"
        >
            <Formik
                onSubmit={handleOnSubmit}
                initialValues={{

                    label: data?.label || ""
                    
                }}
            >
                {({
                    handleSubmit,
                    setFieldValue,
                    handleChange,
                    isValid,
                    values,
                    errors
                }) => (

                    <Form noValidate onSubmit={handleSubmit}>
                        <Modal.Header closeButton>
                            <Modal.Title>{titleForm}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="py-4 px-4">
                            <Form.Group as={Row} controlId="validationCustom01">
                                <Col xs={2}>
                                    <LabelWithValue label={'Tên'} value={''} />
                                </Col>
                                <Col xs={10}>
                                    <Form.Control
                                        type="text"
                                        placeholder=""
                                        name="label"
                                        value={values.label}
                                        onChange={handleChange}
                                        isInvalid={!!errors.label}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.label}</Form.Control.Feedback>
                                </Col>

                            </Form.Group>
  
                        </Modal.Body>
                        <Modal.Footer>
                            <Button onClick={onClose} variant="secondary">Đóng hộp thoại</Button>
                            <Button disabled={!isValid} type="submit" variant="info">{saveLabel}</Button>
                        </Modal.Footer>
                    </Form>
                )}
            </Formik>

        </Modal>
    );
};

export default EditDocumentTypeModal;
